import produce from "immer";
import { PageAction, UPDATE_PAGE } from "./page.actions";
import UmbracoPageRootState from "app/umbraco/models/page-redux-state.interface";

const initialState: UmbracoPageRootState = {
    content: undefined,
    statusCode: 0,
    redirectUrl: undefined,
};

export default (pageState = initialState, action: PageAction): UmbracoPageRootState => produce(pageState, draft => {
    switch (action.type) {
        case UPDATE_PAGE: {
            draft.content = action.content;
            draft.statusCode = action.statusCode;
            draft.redirectUrl = action.redirectUrl;
            break;
        }
    }
});
